import { render, staticRenderFns } from "./projectSelector.vue?vue&type=template&id=45d34cdb&scoped=true&"
import script from "./projectSelector.vue?vue&type=script&lang=js&"
export * from "./projectSelector.vue?vue&type=script&lang=js&"
import style0 from "./projectSelector.vue?vue&type=style&index=0&id=45d34cdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d34cdb",
  null
  
)

export default component.exports